import React from 'react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { type ScheduleItem, type ScheduleQuestion, type ScheduleOccurrence } from '../../../utils/scheduleTransform';
import ScheduleItemRow from './ScheduleItemRow';

interface RecentSchedulesProps {
  schedules: ScheduleItem[];
  isExpanded: boolean;
  onToggleExpanded: () => void;
  readIds: Set<string>;
  expandedIds: string[];
  expandedQuestionIds: string[];
  selectedOccurrenceId: string | null;
  openMenuId: string | null;

  onToggleExpand: (id: string) => void;
  onToggleExpandQuestion: (id: string) => void;
  onMarkRead: (occurrenceId: string) => void;
  onMarkUnread: (occurrenceId: string) => void;
  onOccurrenceSelect: (item: ScheduleItem, question: ScheduleQuestion, occurrence: ScheduleOccurrence) => void;
  onSetOpenMenuId: (id: string | null) => void;
}

const RecentSchedules: React.FC<RecentSchedulesProps> = ({
  schedules,
  isExpanded,
  onToggleExpanded,
  readIds,
  expandedIds,
  expandedQuestionIds,
  selectedOccurrenceId,
  openMenuId,

  onToggleExpand,
  onToggleExpandQuestion,
  onMarkRead,
  onMarkUnread,
  onOccurrenceSelect,
  onSetOpenMenuId,
}) => {
  return (
    <div>
      <button
        onClick={onToggleExpanded}
        className="w-full flex items-center gap-2 px-2 py-1.5 group"
      >
        <span className="text-eai-ink-faint">
          {isExpanded ? <FiChevronDown size={13} /> : <FiChevronRight size={13} />}
        </span>
        <span className="eai-eyebrow transition-colors group-hover:text-eai-ink">
          Recent
        </span>
        {schedules.length > 0 && (
          <span className="eai-tag-pill-sm px-1.5 py-0 text-eai-caption">
            {schedules.length}
          </span>
        )}
        <span className="ml-1 h-px flex-1 bg-eai-surface-active" />
      </button>

      {isExpanded && (
        <div className="mt-1 space-y-1">
          {schedules.length === 0 ? (
            <p className="px-4 py-2 text-eai-body-xs text-eai-ink-faint italic">No new results</p>
          ) : (
            schedules.map((item) => (
              <ScheduleItemRow
                key={item.id}
                item={item}
                readIds={readIds}
                expandedIds={expandedIds}
                expandedQuestionIds={expandedQuestionIds}
                selectedOccurrenceId={selectedOccurrenceId}
                openMenuId={openMenuId}

                onToggleExpand={onToggleExpand}
                onToggleExpandQuestion={onToggleExpandQuestion}
                onMarkRead={onMarkRead}
                onMarkUnread={onMarkUnread}
                onOccurrenceSelect={onOccurrenceSelect}
                onSetOpenMenuId={onSetOpenMenuId}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default RecentSchedules;
